import { render, staticRenderFns } from "./OfferAcceptedPage.vue?vue&type=template&id=08505c6a&scoped=true&"
import script from "./OfferAcceptedPage.vue?vue&type=script&lang=js&"
export * from "./OfferAcceptedPage.vue?vue&type=script&lang=js&"
import style0 from "./OfferAcceptedPage.vue?vue&type=style&index=0&id=08505c6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08505c6a",
  null
  
)

export default component.exports